import PropTypes from 'prop-types';
import {useState, useEffect} from 'react';
import clsx from 'clsx';

import {useUrl} from '@shopify/hydrogen';
import {ReactComponent as SearchIcon} from '~/assets/icons/search.svg';
import {manualUrlParams} from '~/consts/urlParams';
import {useAutoFocus} from '~/hooks/useAutoFocus';
import {trackClickEvent} from '~/utils/trackClickEvent';

export function SearchForm({
  formId,
  placeholderText,
  hasIconInPlaceholder = false,
  focusDep = false,
}) {
  const [searchTerm, setSearchTerm] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    const url = new URL(`${window.location.origin}/products`);

    searchTerm
      ? url.searchParams.set(manualUrlParams.SEARCH_TERM, searchTerm)
      : url.searchParams.delete(manualUrlParams.SEARCH_TERM);
    trackClickEvent('search_click', {search_term: searchTerm});
    window.location.href = url;
  };

  const {searchParams: urlParms} = useUrl();

  useEffect(() => {
    if (urlParms.get(manualUrlParams.SEARCH_TERM)) {
      setSearchTerm(urlParms.get(manualUrlParams.SEARCH_TERM));
    }
  }, [urlParms]);

  const inputRef = useAutoFocus(focusDep);

  const input = (
    <input
      type="text"
      placeholder={placeholderText}
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
      ref={inputRef}
      minLength="3"
    />
  );

  return (
    <form
      className={clsx(
        'form form--inline',
        hasIconInPlaceholder && 'form--search',
      )}
      id={formId}
      onSubmit={handleSubmit}
    >
      {hasIconInPlaceholder ? (
        <div className="form__input-icon-wrapper">
          <SearchIcon />
          {input}
        </div>
      ) : (
        <>{input}</>
      )}

      <button className={`btn`} type="submit">
        Search
      </button>
    </form>
  );
}

SearchForm.propTypes = {
  formId: PropTypes.string.isRequired,
  placeholderText: PropTypes.string.isRequired,
  hasIconInPlaceholder: PropTypes.bool,
  focusDep: PropTypes.bool,
};
